import React from 'react'

import './ServicePenalty.scss'

function ServicePenalty ({ penalty }) {
  const hasPenalty = penalty && penalty.message
  return hasPenalty
    ? <p className='ServicePenalty'> {penalty.message} </p>
    : <p />
}

ServicePenalty.displayName = 'ServicePenalty'

export default ServicePenalty



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ServicePenalty/ServicePenalty.js